

import { useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import {  loginSuccessP } from "../redux/slices/pensSlice";

import apiService from "../api/ApiService";
import { useForm } from "react-hook-form";
import { Category, Close, Title } from "@mui/icons-material";
const moment=require('moment-jalaali');


const CreatePen=({allPenss})=>{
    const {currentSfarm}=useSelector(state=>state.p.sFarm)
    const {currentPens}=useSelector(state=>state.pens)
    
  
    const {
        register,
        handleSubmit,
        formState: { errors }
      } = useForm();
    const [allPens,setAllPens]=useState(allPenss)
    const {openModalls2,isOpenModal2,closeModalls2}=useGlobalContext();
   
    const dispatch=useDispatch();
    
    


    const newPen=async(data)=>{           
                    const data1=JSON.stringify({...data,type:+data?.type,farmId:currentSfarm.id})
                    const res=await apiService.addNewPen(data1);
                    dispatch(loginSuccessP([...currentPens,res.data]))
                    openModalls2()
    }
    

    return <div onClick={closeModalls2} className={`modal-overlay ${isOpenModal2&&'show-modal'} `}>
        <form onSubmit={handleSubmit(newPen)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <AddToPhotosIcon fontSize="large"/>

            <h4 > ایجاد بهاربند جدید</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("name",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Title fontSize="small"/> نام بهاربند</label>
            {errors?.name?.message&&<span className='errMsg'>{errors.name.message}</span>}
        </div>
        <div className="SelConn">
        <label for='sele' ><Category fontSize="small"/> دسته:</label>
        <select id='sele' name='sele' className="selectInp" {...register("type",{required:'این مقدار ضروری است'})}>
            
            {
                allPens.map((item,index)=>{
                        return <option key={index} value={item.id}>{item.title}</option>
                })

            }
        </select>
        {errors?.type?.message&&<span className='errMsg'>{errors.type.message}</span>}
        </div>
        <button className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default  CreatePen